import React from 'react';
import './SideBar.css';
import NavItem from './NavItem';
import navList from '../DataStatic/navList';
import { FaFileAlt, FaBullseye, FaEye, FaLifeRing, FaShieldAlt, 
  FaCheck, FaTimes, FaAward, FaGavel, FaExclamationTriangle, FaStamp,  FaCog, FaMicrophoneAlt, FaPenAlt, FaPaperPlane, FaCloud, FaUser, FaFlag, FaChessKnight, FaLock, FaAtom, FaDatabase
} from 'react-icons/fa';

function SideBar({ onNavClick, filterCondition,  onToggleSidebar, collapsed, feedbackCount, setFeedbackCount, feedbackSummary, feedbackId, setFeedbackId }) {
  const handleNavClick = (name) => {
    if (name === 'Documentation') return;
    onNavClick(name);

    if (name === 'Feedback') {
      setFeedbackCount();

      // If only one message, auto-select it
      if (feedbackSummary?.messages?.length === 1) {
        setFeedbackId(feedbackSummary.messages[0]._id);
      } else {
        setFeedbackId(null); // User must choose
      }
    }
  };

  const handleDocumentationClick = () => {
    // Open external URL in new tab
    window.open('https://mspb-articles.contranormdigital.com/', '_blank', 'noopener,noreferrer');
  };

  const appliedFilterCondition = typeof filterCondition === 'function' ? filterCondition : () => true;
  const filteredNavList = navList.filter(appliedFilterCondition);

  const getIcon = (navItem) => {
    const iconMap = {
      'Privacy': <FaLock className="client-sidebar-icon" />,
      'Terms & Conditions': <FaFileAlt className="client-sidebar-icon" />,
      'Mission': <FaBullseye className="client-sidebar-icon" />,
      'Vision': <FaEye className="client-sidebar-icon" />,
      'Support': <FaLifeRing className="client-sidebar-icon" />,
      'DCMA': <FaShieldAlt className="client-sidebar-icon" />,
      'Check': <FaCheck className="client-sidebar-icon" />,
      'Times': <FaTimes className="client-sidebar-icon" />,
      'Ownership': <FaAward className="client-sidebar-icon" />,
      'Code of Conduct': <FaGavel className="client-sidebar-icon" />,
      'Termination': <FaExclamationTriangle className="client-sidebar-icon" />,
      'Copyright': <FaStamp className="client-sidebar-icon" />,
      'Block User': <FaFlag className="client-sidebar-icon" />,
      'Contacts': <FaUser className="client-sidebar-icon" />,
      'Upload Quiz': <FaCloud className="client-sidebar-icon" />,
      'SAT': <FaEye className="client-sidebar-icon" />,
      'Deliverable': <FaPaperPlane className="client-sidebar-icon" />,
      'Feedback': <FaPenAlt className="client-sidebar-icon" />,
      'Database': <FaDatabase className="client-sidebar-icon" />,
      'Settings': <FaCog className="client-sidebar-icon" />,
      'Support Services': <FaMicrophoneAlt className="client-sidebar-icon" />,
      'Administrative Hearing': <FaChessKnight className="client-sidebar-icon" />,
      'MSPB': <FaGavel className="client-sidebar-icon" />,
      'Documentation': <FaFileAlt  className="client-sidebar-icon" />,
      'Action Required': <FaAtom className="client-sidebar-icon" />,
     
    };
  
    // Check if the navItem._id > 7, return corresponding icon if present
    return iconMap[navItem.name] || null;
  };
  


  return (
    <aside id="sidebar" className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <ul className="sidebar-nav" id="sidebar-nav">
        {filteredNavList.map(nav => {
          const isFeedback = nav.name === 'Feedback';
          const isDocumentation = nav.name === 'Documentation';
          return (
            <li key={nav._id} className="sidebar-nav-item-wrapper" style={{ position: 'relative' }}>
               {isDocumentation ? (
                // Custom handling for Documentation item
                <div 
                  className="nav-item documentation-item" 
                  onClick={handleDocumentationClick}
                  style={{cursor: 'pointer'}}
                >
                  <div className="nav-icon">
                    {getIcon(nav)}
                  </div>
                  {!collapsed && (
                    <div className="nav-name">
                      <span>{nav.name}</span>
                    </div>
                  )}
                </div>
              ) : (
                <NavItem
                  nav={nav}
                  onClick={() => handleNavClick(nav.name)}
                  icon={getIcon(nav)}
                  collapsed={collapsed}
                />
               )}
                {isFeedback && feedbackCount > 0 && (
                  <span className="feedback-badge">{feedbackCount}</span>
                )}
            </li>
          );
        })}
      </ul>

      <div
        className="sidebar-toggle-btn"
        onClick={onToggleSidebar}
        style={{ pointerEvents: collapsed && window.innerWidth <= 920 ? 'none' : 'auto' }}
      >
        <FaTimes className="toggle-icon" />
      </div>
    </aside>
  );
}

export default SideBar;
